export const FUEL_FIELDS = [
    { name: "fuelType", label: "Fuel Type", type: "fuel", required: true },
    { name: "cf", label: "CF", type: "number", size: "md", required: true },
    { name: "amount", label: "Amount (MT)", type: "number", size: "md", required: true },
];

export const CORRECTION_FIELDS = [
    { name: "fuelType", label: "Fuel Type", type: "fuel", required: true },
    { name: "cf", label: "CF", type: "number", required: true },
    { name: "fcVoyage", label: "FC voyage", type: "number", required: false },
    { name: "tfj", label: "TFj", type: "number", required: false },
    { name: "fcElectrical", label: "FC electrical", type: "number", required: false },
    { name: "fcBoiler", label: "FC boiler", type: "number", required: false },
    { name: "fcOther", label: "FC other", type: "number", required: false },
];

export const REPORT_FIELDS = [
    { name: "reportingStart", label: "Reporting Start", type: "date", required: true },
    { name: "reportingEnd", label: "Reporting End", type: "date", required: true },
    { name: "distanceTravelled", label: "Distance Travelled (nm)", type: "number", required: true },
    { name: "distanceExcluded", label: "Distance Excluded (nm)", type: "number" },
];
